var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWidth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_100)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2384 5.65308L13.4113 5.42043L13.7366 5.38549L13.7703 5.71114L13.9945 7.88467L13.3465 7.95085L13.2033 6.56363L7.30502 13.8482L8.6919 13.6994L8.76174 14.3473L6.58912 14.5801L6.26358 14.6149L6.23009 14.2894L6.00567 12.1157L6.6539 12.0492L6.79686 13.4367L12.6951 6.15217L11.3085 6.30068L11.2384 5.65308ZM3.08767 12.5695L8.92484 17.2958L8.51359 17.8037L2.67643 13.0774L3.08767 12.5695ZM11.4866 2.19662L17.3237 6.92297L16.9127 7.43059L11.0755 2.70424L11.4866 2.19662Z",
    fill: "#3CBD96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(8.96484 0.154785) rotate(38.9971)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidth);
export default __webpack_public_path__ + "static/media/width.44da27ea19da4e3a0ebc0cead1ff4db8.svg";
export { ForwardRef as ReactComponent };